
























































































































































import DCheckbox from '~/components/atoms/DS2/DCheckbox'
import DRadio from '~/components/atoms/DS2/DRadio'
import {
  defineComponent,
  PropType,
  inject,
  toRefs,
  onMounted,
  ComputedRef,
  computed,
  ref
} from '@nuxtjs/composition-api'
import { useSearchConditionSelect } from '~/components/logics/search/search-condition-select-cassette-hooks'
import SearchConditionSelectPrice from '~/components/organisms/DS2/SearchConditionSelectPrice'
import { ConditionOptionCommon } from '~/types/services/search'
import { Category, serviceSearchOptionValue } from '~/stub/apigateway/master/master_pb'

const searchConditionSelectModalCassette = defineComponent({
  name: 'SearchConditionSelectModalCassette',
  components: {
    DCheckbox,
    DRadio,
    SearchConditionSelectPrice
  },
  props: {
    searchCondition: {
      type: Object as PropType<ConditionOptionCommon>,
      default: () => ({})
    },
    isPricesGroup: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    isAllGroup: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    facetGroupKey: {
      type: String,
      default: false
    }
  },
  setup(props, context) {
    const { searchCondition } = toRefs(props)
    const selectedCondition = inject('selectedSearchConditionAll')
    const categoryMasterRef = inject<ComputedRef<Category.AsObject>>('categoryMasterRef')

    const {
      selectedUnitPriceMin,
      selectedUnitPriceMax,
      omittedSearchConditionItems,
      expandSearchConditionItems,
      isExpanded,
      expandTriggerLabel,
      onClickExpandTrigger,
      isShowSelectCassette,
      isShowSearchConditionItem,
      changePrice
    } = useSearchConditionSelect(
      searchCondition.value,
      selectedCondition,
      categoryMasterRef.value
    )

    const shownOmittedSearchConditionItems = computed(() => {
      return omittedSearchConditionItems.value.filter(v => isShowSearchConditionItem(v.valueKey, v.value))
    })

    const shownExpandSearchConditionItems = computed(() => {
      return expandSearchConditionItems.value.filter(v => isShowSearchConditionItem(v.valueKey, v.value))
    })

    onMounted(() => {
      if (selectedCondition[searchCondition.value.master.key]?.length) {
        isExpanded.value = true
      }
    })

    // DInputとBInputで計2回inputイベントが同時発火するので同一フレーム内でthrottlingする
    const throttlingInputEvent = ref(false)
    const onInputSearchConditionItem = (item: serviceSearchOptionValue.AsObject) => {
      if (!throttlingInputEvent.value && item.valueKey === 'service_kind') {
        throttlingInputEvent.value = true
        context.emit('change-service-kind', item)
        requestAnimationFrame(() => {
          throttlingInputEvent.value = false
        })
      }
    }

    return {
      selectedUnitPriceMin,
      selectedUnitPriceMax,
      changePrice,
      selectedCondition,
      expandTriggerLabel,
      shownOmittedSearchConditionItems,
      expandSearchConditionItems,
      shownExpandSearchConditionItems,
      isExpanded,
      isShowSelectCassette,
      isShowSearchConditionItem,
      onClickExpandTrigger,
      onInputSearchConditionItem
    }
  }
})
export default searchConditionSelectModalCassette
